/**
 * Generated by orval v8.4.0 🍺
 * Do not edit manually.
 * Medme Marketing PRM API
 * API для автоматизированных маркетинговых рассылок и выгрузок (MedMe PRM).

**Разделы продукта:**
- **Рассылки** — отправка сообщений по сегменту (разово или по расписанию)
- **Выгрузки** — таблица пациентов по сегменту (файл, опционально e-mail с архивом)
- **Отчётность** — журнал запусков и доставки

**Авторизация:** HttpOnly cookie `token` (JWT), как в stats-api. Получение токена — через `GET /auth` stats-api.

**Контекст организации:** API работает с понятием «организация» — всем списком бизнесов, к которым у пользователя есть доступ. Сервер резолвит бизнесы автоматически из JWT-токена; `businessId` в query-параметрах не передаётся. Для операций над конкретным бизнесом (создание задачи, принятие условий) `businessId` передаётся в теле запроса.

 * OpenAPI spec version: 1.0.0
 */
import { faker } from "@faker-js/faker"
import type { RequestHandlerOptions } from "msw"
import { delay, HttpResponse, http } from "msw"
import type {
	MarketingFilterMetadataResponse,
	SavedSegment,
	SavedSegmentListResponse,
	SegmentPreviewResponse,
} from ".././types/marketing"
import { MarketingAudienceRulesMatch } from ".././types/marketing"

export const getGetMarketingFilterMetadataResponseMock = (
	overrideResponse: Partial<
		Extract<MarketingFilterMetadataResponse, object>
	> = {},
): MarketingFilterMetadataResponse => ({
	rules: Array.from(
		{ length: faker.number.int({ min: 1, max: 5 }) },
		(_, i) => i + 1,
	).map(() => ({
		name: faker.string.alpha({ length: { min: 10, max: 20 } }),
		label: faker.helpers.arrayElement([
			faker.string.alpha({ length: { min: 10, max: 20 } }),
			undefined,
		]),
		type: faker.helpers.arrayElement([
			"fio",
			"phone",
			"string",
			"ddl",
			"service",
			"business",
			"resource",
			"specialization",
			"number",
			"range",
		] as const),
		operators: Array.from(
			{ length: faker.number.int({ min: 1, max: 5 }) },
			(_, i) => i + 1,
		).map(() => faker.string.alpha({ length: { min: 10, max: 20 } })),
		enumValues: faker.helpers.arrayElement([
			Array.from(
				{ length: faker.number.int({ min: 1, max: 5 }) },
				(_, i) => i + 1,
			).map(() => faker.string.alpha({ length: { min: 10, max: 20 } })),
			undefined,
		]),
	})),
	popularPresets: Array.from(
		{ length: faker.number.int({ min: 1, max: 5 }) },
		(_, i) => i + 1,
	).map(() => ({
		id: faker.string.alpha({ length: { min: 10, max: 20 } }),
		label: faker.string.alpha({ length: { min: 10, max: 20 } }),
		rules: Array.from(
			{ length: faker.number.int({ min: 1, max: 5 }) },
			(_, i) => i + 1,
		).map(() => ({
			name: "client_birthday",
			operator: "birthday_eq",
			value: faker.helpers.arrayElement([
				faker.string.alpha({ length: { min: 10, max: 20 } }),
				faker.number.float({ fractionDigits: 2 }),
				faker.datatype.boolean(),
				Array.from(
					{ length: faker.number.int({ min: 1, max: 5 }) },
					(_, i) => i + 1,
				).map(() => ({})),
			]),
		})),
	})),
	branches: faker.helpers.arrayElement([
		Array.from(
			{ length: faker.number.int({ min: 1, max: 5 }) },
			(_, i) => i + 1,
		).map(() => ({
			id: faker.string.alpha({ length: { min: 10, max: 20 } }),
			name: faker.string.alpha({ length: { min: 10, max: 20 } }),
		})),
		undefined,
	]),
	services: faker.helpers.arrayElement([
		Array.from(
			{ length: faker.number.int({ min: 1, max: 5 }) },
			(_, i) => i + 1,
		).map(() => ({
			id: faker.string.alpha({ length: { min: 10, max: 20 } }),
			name: faker.string.alpha({ length: { min: 10, max: 20 } }),
		})),
		undefined,
	]),
	specializations: faker.helpers.arrayElement([
		Array.from(
			{ length: faker.number.int({ min: 1, max: 5 }) },
			(_, i) => i + 1,
		).map(() => ({
			id: faker.string.alpha({ length: { min: 10, max: 20 } }),
			name: faker.string.alpha({ length: { min: 10, max: 20 } }),
		})),
		undefined,
	]),
	resources: faker.helpers.arrayElement([
		Array.from(
			{ length: faker.number.int({ min: 1, max: 5 }) },
			(_, i) => i + 1,
		).map(() => ({
			id: faker.string.alpha({ length: { min: 10, max: 20 } }),
			name: faker.string.alpha({ length: { min: 10, max: 20 } }),
			specializationId: faker.helpers.arrayElement([
				faker.string.alpha({ length: { min: 10, max: 20 } }),
				undefined,
			]),
			specializationName: faker.helpers.arrayElement([
				faker.string.alpha({ length: { min: 10, max: 20 } }),
				undefined,
			]),
		})),
		undefined,
	]),
	...overrideResponse,
})

export const getPreviewMarketingSegmentResponseMock = (
	overrideResponse: Partial<Extract<SegmentPreviewResponse, object>> = {},
): SegmentPreviewResponse => ({
	count: 7696,
	countBeforeExclusions: 7696,
	totalInBase: 7696,
	percent: 100,
	overLimit: faker.datatype.boolean(),
	limit: 5000,
	estimatedBillableMessages: faker.helpers.arrayElement([
		faker.number.int(),
		null,
	]),
	...overrideResponse,
})

export const getListSavedSegmentsResponseMock = (
	overrideResponse: Partial<Extract<SavedSegmentListResponse, object>> = {},
): SavedSegmentListResponse => ({
	data: Array.from(
		{ length: faker.number.int({ min: 1, max: 5 }) },
		(_, i) => i + 1,
	).map(() => ({
		id: faker.string.alpha({ length: { min: 10, max: 20 } }),
		name: faker.string.alpha({ length: { min: 10, max: 20 } }),
		rules: Array.from(
			{ length: faker.number.int({ min: 1, max: 5 }) },
			(_, i) => i + 1,
		).map(() => ({
			name: "client_birthday",
			operator: "birthday_eq",
			value: faker.helpers.arrayElement([
				faker.string.alpha({ length: { min: 10, max: 20 } }),
				faker.number.float({ fractionDigits: 2 }),
				faker.datatype.boolean(),
				Array.from(
					{ length: faker.number.int({ min: 1, max: 5 }) },
					(_, i) => i + 1,
				).map(() => ({})),
			]),
		})),
		rulesMatch: faker.helpers.arrayElement([
			faker.helpers.arrayElement(Object.values(MarketingAudienceRulesMatch)),
			undefined,
		]),
	})),
	paging: {
		page: faker.number.int(),
		pageSize: faker.number.int(),
		total: faker.number.int(),
	},
	...overrideResponse,
})

export const getSaveMarketingSegmentResponseMock = (
	overrideResponse: Partial<Extract<SavedSegment, object>> = {},
): SavedSegment => ({
	id: faker.string.alpha({ length: { min: 10, max: 20 } }),
	name: faker.string.alpha({ length: { min: 10, max: 20 } }),
	rules: Array.from(
		{ length: faker.number.int({ min: 1, max: 5 }) },
		(_, i) => i + 1,
	).map(() => ({
		name: "client_birthday",
		operator: "birthday_eq",
		value: faker.helpers.arrayElement([
			faker.string.alpha({ length: { min: 10, max: 20 } }),
			faker.number.float({ fractionDigits: 2 }),
			faker.datatype.boolean(),
			Array.from(
				{ length: faker.number.int({ min: 1, max: 5 }) },
				(_, i) => i + 1,
			).map(() => ({})),
		]),
	})),
	rulesMatch: faker.helpers.arrayElement([
		faker.helpers.arrayElement(Object.values(MarketingAudienceRulesMatch)),
		undefined,
	]),
	...overrideResponse,
})

export const getUpdateSavedSegmentResponseMock = (
	overrideResponse: Partial<Extract<SavedSegment, object>> = {},
): SavedSegment => ({
	id: faker.string.alpha({ length: { min: 10, max: 20 } }),
	name: faker.string.alpha({ length: { min: 10, max: 20 } }),
	rules: Array.from(
		{ length: faker.number.int({ min: 1, max: 5 }) },
		(_, i) => i + 1,
	).map(() => ({
		name: "client_birthday",
		operator: "birthday_eq",
		value: faker.helpers.arrayElement([
			faker.string.alpha({ length: { min: 10, max: 20 } }),
			faker.number.float({ fractionDigits: 2 }),
			faker.datatype.boolean(),
			Array.from(
				{ length: faker.number.int({ min: 1, max: 5 }) },
				(_, i) => i + 1,
			).map(() => ({})),
		]),
	})),
	rulesMatch: faker.helpers.arrayElement([
		faker.helpers.arrayElement(Object.values(MarketingAudienceRulesMatch)),
		undefined,
	]),
	...overrideResponse,
})

export const getGetMarketingFilterMetadataMockHandler = (
	overrideResponse?:
		| MarketingFilterMetadataResponse
		| ((
				info: Parameters<Parameters<typeof http.get>[1]>[0],
		  ) =>
				| Promise<MarketingFilterMetadataResponse>
				| MarketingFilterMetadataResponse),
	options?: RequestHandlerOptions,
) => {
	return http.get(
		"*/marketing/filters/metadata",
		async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {
			await delay(300)

			return HttpResponse.json(
				overrideResponse !== undefined
					? typeof overrideResponse === "function"
						? await overrideResponse(info)
						: overrideResponse
					: getGetMarketingFilterMetadataResponseMock(),
				{ status: 200 },
			)
		},
		options,
	)
}

export const getPreviewMarketingSegmentMockHandler = (
	overrideResponse?:
		| SegmentPreviewResponse
		| ((
				info: Parameters<Parameters<typeof http.post>[1]>[0],
		  ) => Promise<SegmentPreviewResponse> | SegmentPreviewResponse),
	options?: RequestHandlerOptions,
) => {
	return http.post(
		"*/marketing/segments/preview",
		async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {
			await delay(300)

			return HttpResponse.json(
				overrideResponse !== undefined
					? typeof overrideResponse === "function"
						? await overrideResponse(info)
						: overrideResponse
					: getPreviewMarketingSegmentResponseMock(),
				{ status: 200 },
			)
		},
		options,
	)
}

export const getListSavedSegmentsMockHandler = (
	overrideResponse?:
		| SavedSegmentListResponse
		| ((
				info: Parameters<Parameters<typeof http.get>[1]>[0],
		  ) => Promise<SavedSegmentListResponse> | SavedSegmentListResponse),
	options?: RequestHandlerOptions,
) => {
	return http.get(
		"*/marketing/segments/saved",
		async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {
			await delay(300)

			return HttpResponse.json(
				overrideResponse !== undefined
					? typeof overrideResponse === "function"
						? await overrideResponse(info)
						: overrideResponse
					: getListSavedSegmentsResponseMock(),
				{ status: 200 },
			)
		},
		options,
	)
}

export const getSaveMarketingSegmentMockHandler = (
	overrideResponse?:
		| SavedSegment
		| ((
				info: Parameters<Parameters<typeof http.post>[1]>[0],
		  ) => Promise<SavedSegment> | SavedSegment),
	options?: RequestHandlerOptions,
) => {
	return http.post(
		"*/marketing/segments/saved",
		async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {
			await delay(300)

			return HttpResponse.json(
				overrideResponse !== undefined
					? typeof overrideResponse === "function"
						? await overrideResponse(info)
						: overrideResponse
					: getSaveMarketingSegmentResponseMock(),
				{ status: 201 },
			)
		},
		options,
	)
}

export const getUpdateSavedSegmentMockHandler = (
	overrideResponse?:
		| SavedSegment
		| ((
				info: Parameters<Parameters<typeof http.put>[1]>[0],
		  ) => Promise<SavedSegment> | SavedSegment),
	options?: RequestHandlerOptions,
) => {
	return http.put(
		"*/marketing/segments/saved/:segmentId",
		async (info: Parameters<Parameters<typeof http.put>[1]>[0]) => {
			await delay(300)

			return HttpResponse.json(
				overrideResponse !== undefined
					? typeof overrideResponse === "function"
						? await overrideResponse(info)
						: overrideResponse
					: getUpdateSavedSegmentResponseMock(),
				{ status: 200 },
			)
		},
		options,
	)
}

export const getDeleteSavedSegmentMockHandler = (
	overrideResponse?:
		| void
		| ((
				info: Parameters<Parameters<typeof http.delete>[1]>[0],
		  ) => Promise<void> | void),
	options?: RequestHandlerOptions,
) => {
	return http.delete(
		"*/marketing/segments/saved/:segmentId",
		async (info: Parameters<Parameters<typeof http.delete>[1]>[0]) => {
			await delay(300)
			if (typeof overrideResponse === "function") {
				await overrideResponse(info)
			}

			return new HttpResponse(null, { status: 204 })
		},
		options,
	)
}
export const getMarketingSegmentsMock = () => [
	getGetMarketingFilterMetadataMockHandler(),
	getPreviewMarketingSegmentMockHandler(),
	getListSavedSegmentsMockHandler(),
	getSaveMarketingSegmentMockHandler(),
	getUpdateSavedSegmentMockHandler(),
	getDeleteSavedSegmentMockHandler(),
]
